function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  height: 1px;\n  width: 1px;\n  position: absolute;\n  overflow: hidden;\n  top: -10px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import styled from 'styled-components';
// W3C recommended solution for accessible link text https://www.w3.org/TR/2012/NOTE-WCAG20-TECHS-20120103/C7
export default styled.span(_templateObject());
